export default "__VITE_ASSET__C5eNNxtP__"